import React from 'react';
import { Table, Button, Checkbox } from 'antd';
import { CloseOutlined } from '@ant-design/icons';

function Expandtable(props) {
	const { record, removeSelectedExamByExam, onchangeStatChange, onchangeSendout, exams } = props;
	const isSectionLocked = record['isSectionLocked'];
	const SelectedExams = record['exams'];

	const NewTableData = SelectedExams.map(selectedExam => {
		return {
			key: selectedExam.examID,
			...selectedExam,
			action:
				!selectedExam.isLocked && !isSectionLocked ? (
					<Button
						type="dashed"
						icon={<CloseOutlined />}
						size="small"
						onClick={() => removeSelectedExamByExam(selectedExam)}
					/>
				) : null,

			actionSendOut: (
				<Checkbox
					disabled={selectedExam.examRequestAutoSendOutDisable || isSectionLocked}
					checked={selectedExam.examRequestAutoSendOut === 1}
					onChange={e => onchangeSendout(selectedExam.examID, e.target.checked)}
				/>
			),
			actionStat: (
				<Checkbox
					disabled={selectedExam.examRequestAutoSTATIsDisable || isSectionLocked}
					checked={selectedExam.examRequestAutoSTAT === 1}
					onChange={e => onchangeStatChange(selectedExam, e.target.checked)}
				/>
			),
		};
	});

	const columns = [
		{
			title: 'Exam Name',
			dataIndex: 'examName',
			width: 200,
		},
		{
			title: 'Panel',
			dataIndex: ['selectedPanel', 'panelName'],
			width: 200,
		},
		{
			title: 'Send Out',
			dataIndex: 'actionSendOut',
			width: 100,
		},
		{
			title: 'Stat',
			dataIndex: 'actionStat',
			width: 100,
		},
		{
			title: 'Action',
			dataIndex: 'action',
			width: 100,
			align: 'center',
		},
	];

	return (
		<Table
			defaultExpandAllRows={true}
			key={NewTableData.length}
			dataSource={NewTableData}
			columns={columns}
			pagination={false}
		/>
	);
}

export default Expandtable;
